import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
 import App from './App';
// import * as serviceWorker from './serviceWorker';
// import Testcsv from './Testcsv';
// import Mon_test from './Mon_test';


 ReactDOM.render(<App />, document.getElementById('racine_serveur'));

// ReactDOM.render(<Testcsv />, document.getElementById('racine_serveur'));

// ReactDOM.render(<Mon_test />, document.getElementById('racine_serveur'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
